import { defineMessages } from "react-intl";

export default defineMessages({
  serviceFeeFormulaShort: {
    id: "serviceFeeFormulaCard.serviceFeeFormulaShort",
    defaultMessage: "Service fee",
  },
  serviceFeeFormula: {
    id: "serviceFeeFormulaCard.serviceFeeFormula",
    defaultMessage: "Service fee formula",
  },
  choose: {
    id: "serviceFeeFormulaCard.choose",
    defaultMessage: "Choose",
  },
  viewPriceEstimate: {
    id: "serviceFeeFormulaCard.viewPriceEstimate",
    defaultMessage: "View price estimate",
  },
  ourServiceFeeFormulaIsCurrentlyDisabled: {
    id: "contractAcceptance.ourServiceFeeFormulaIsCurrentlyDisabled",
    defaultMessage:
      "Our standard formula is currently disabled. Please contact a platform administrator for more information.",
  },
  unavailable: {
    id: "contractAcceptance.unavailable",
    defaultMessage: "Unavailable",
  },
  weSeeThatYoureAnAdmin: {
    id: "contractAcceptance.weSeeThatYoureAnAdmin",
    defaultMessage:
      "We see that you're an admin. Please confirm that the <bold>service_fees</bold> feature is supposed to be disabled, or enabled it yourself via the Feature Flags tool. If you're not sure, please contact a platform administrator.",
  },
  goToFeatureFlagsAdmin: {
    id: "contractAcceptance.goToFeatureFlagsAdmin",
    defaultMessage: "Go to Feature Flags admin",
  },
  serviceFeeAppliedOnTheService: {
    id: "serviceFeeFormulaCard.serviceFeeAppliedOnTheService",
    defaultMessage: "Service fee applied on the service.",
  },
  getATasteOfOurServices: {
    id: "serviceFeeFormulaCard.getATasteOfOurServices",
    defaultMessage: "Get a taste of our services.",
  },
});
